// extracted by mini-css-extract-plugin
export var container = "_bf-0";
export var content = "_bf-3";
export var customerTitle = "_bf-4";
export var empty = "_bf-5";
export var gray = "_bf-6";
export var header = "_bf-7";
export var info = "_bf-8";
export var loading = "_bf-2";
export var loadingCard = "_bf-9";
export var oneLine = "_bf-a";
export var personName = "_bf-e";
export var pillContainer = "_bf-b";
export var selected = "_bf-1";
export var text = "_bf-c";
export var twoLines = "_bf-d";
export var unread = "_bf-f";
export var unreadIndicator = "_bf-g";